var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "session-dialog-component" },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            "content-class": "expand overlay-dialog geolocation-dialog",
            persistent: "",
            height: "90%"
          },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _vm.sessionDialogData.context === "sessiontime"
            ? [
                _c(
                  "div",
                  { staticClass: "header" },
                  [
                    _c(
                      "v-layout",
                      { attrs: { "align-center": "" } },
                      [
                        _c("v-flex", [
                          _c("h1", [
                            _vm._v(_vm._s(_vm.$t("SessionTime.Title")))
                          ])
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "geo-content" },
                  [
                    _c(
                      "v-layout",
                      { attrs: { "align-center": "" } },
                      [
                        _c("v-flex", [
                          _c(
                            "div",
                            { staticClass: "gcontent-container" },
                            [
                              _c(
                                "v-card",
                                { staticClass: "gcontent-container-msg" },
                                [
                                  _c("br"),
                                  _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t("SessionTime.Info2", {
                                          sessionInMinutes: _vm.sessionInMinutes
                                        })
                                      )
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card",
                                { staticClass: "gcontent-container-msg" },
                                [
                                  _c("br"),
                                  _c("p", [_vm._v(_vm._s(_vm.currentTime))])
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "geo-content" }, [
                  _c(
                    "div",
                    { staticClass: "buttons" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "okay-btn",
                          attrs: { block: "" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.closeDialog()
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("SessionTime.Info3")))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            : [
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "okay-btn",
                        attrs: { block: "" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.closeDialog()
                          }
                        }
                      },
                      [_c("span", [_vm._v("Close dialog")])]
                    )
                  ],
                  1
                )
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9cef156c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9cef156c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SessionDialog.vue
// module id = null
// module chunks = 